import React, { useMemo } from "react";
import { type IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import "./styles.scss";
import { useAccountToDisplaySelector } from "../../redux/actions/user";

interface KC_NavlinkI {
  id?: string;
  to: string;
  isActive: boolean;
  text: string;
  icon: IconDefinition | JSX.Element;
  onClick?: any;
}

const KC_Navlink = (props: KC_NavlinkI) => {
  const { accountToDisplay } = useAccountToDisplaySelector();

  const cls = useMemo(() => {
    return ["kc-navlink", props.isActive ? "kc-navlink-active" : ""]
      .filter(Boolean)
      .join(" ");
  }, [props.isActive]);

  return (
    <NavLink
      id={props.id}
      to={props.to}
      onClick={props.onClick}
      className={cls}
    >
      <div
        className={`kc-navlink-content ${
          props.isActive ? "kc-navlink-content-active" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={props.icon as IconDefinition}
          style={{ width: 15, height: 15 }}
        />
        <span>{props.text}</span>
      </div>
    </NavLink>
  );
};

export default KC_Navlink;
